import authToken from '@/api/hooks/auth-token'
import provider from '@/api/hooks/provider'
import prepareForServer from '@/api/hooks/prepare-for-server'

export default function(config = {}) {
  return function() {
    const app = this
    app.mixins.push(function(service) {
      service.hooks(authToken)
      service.hooks(provider)
      service.hooks(prepareForServer)
    })
  }
}
